// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DEFAULT_ROOM_ID: any = null;
